import * as betgalaxy from './Badges.styles.betgalaxy';
import * as betprofessor from './Badges.styles.betprofessor';
import * as betroyale from './Badges.styles.betroyale';
import * as fiestabet from './Badges.styles.fiestabet';
import * as goldenrush from './Badges.styles.goldenrush';
import * as juicybet from './Badges.styles.juicybet';
import * as junglebet from './Badges.styles.junglebet';
import * as questbet from './Badges.styles.questbet';
import * as puntgenie from './Badges.styles.puntgenie';
import * as sterlingparker from './Badges.styles.sterlingparker';
import * as puntcity from './Badges.styles.puntcity';
import * as vikingbet from './Badges.styles.vikingbet';
import * as volcanobet from './Badges.styles.volcanobet';
import * as wellbet from './Badges.styles.wellbet';
import * as sugarcastle from './Badges.styles.sugarcastle';
import * as oldgill from './Badges.styles.oldgill';
import * as buffalobet from './Badges.styles.buffalobet';
import * as titanbet from './Badges.styles.titanbet';
import * as slambet from './Badges.styles.slambet';
import * as gigabet from './Badges.styles.gigabet';
import * as betstride from './Badges.styles.betstride';
import * as templebet from './Badges.styles.templebet';
import * as goldenbet888 from './Badges.styles.goldenbet888';
import * as hyperbet from './Badges.styles.hyperbet';
import * as bet777 from './Badges.styles.bet777';
import * as chromabet from './Badges.styles.chromabet';
import * as bet575 from './Badges.styles.bet575';
import * as betblast from './Badges.styles.betblast';
import * as magnumbet from './Badges.styles.magnumbet';
import * as pyramidbet from './Badges.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  junglebet,
  questbet,
  puntgenie,
  sterlingparker,
  puntcity,
  vikingbet,
  volcanobet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  magnumbet,
  pyramidbet,
};
